import React from 'react';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const ServiceCardLoading = ({ backgroundColor }: { backgroundColor?: string }) => {
  if (backgroundColor) {
    return (
      <Box
        sx={{
          minWidth: {
            xs: '70%',
            sm: '70%',
            md: 'calc(50% - 16px)',
            lg: '333px',
          },
          width: {
            xs: 'calc(50% - 16px)',
            sm: 'calc(50% - 16px)',
            md: 'calc(33.33% - 16px)',
            lg: 'calc(25% - 16px)',
          },
          height: '500px',
          borderRadius: '10px',
          padding: '10px',
          gap: '12px',
          display: 'flex',
          flexDirection: 'column',
          background: backgroundColor || 'transparent',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '48px',
              gap: '4px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton
              variant="rectangular"
              width="80%"
              height="48px"
              animation="wave"
              sx={{
                borderRadius: '5px',
                background: `rgba(155, 121, 100, 0.1)`,
              }}
            />
          </Box>
          <Box
            sx={{
              width: '100%',
              height: '30px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton
              variant="rectangular"
              width="40%"
              height="20px"
              animation="wave"
              sx={{ borderRadius: '5px', background: `rgba(155, 121, 100, 0.1)` }}
            />
          </Box>
          <Box
            sx={{
              width: '100%',
              height: '50px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton
              variant="rectangular"
              width="70px"
              height="70px"
              animation="wave"
              sx={{ borderRadius: '5px', background: `rgba(155, 121, 100, 0.1)` }}
            />
          </Box>
          <Box
            sx={{
              width: '100%',
              height: '150px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height="150px"
              animation="wave"
              sx={{ borderRadius: '5px', background: `rgba(155, 121, 100, 0.1)` }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderTop: '1px solid #EEEEEE',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            gap: '20px',
            mt: '5px',
          }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height="48px"
            animation="wave"
            sx={{ borderRadius: '5px', background: `rgba(155, 121, 100, 0.1)` }}
          />
        </Box>
      </Box>
    );
  }
  return (
    <Box>
      <Skeleton
        variant="rectangular"
        height="500px"
        animation="wave"
        sx={{
          borderRadius: '10px',
          background: `rgba(155, 121, 100, 0.1)`,
          minWidth: {
            xs: '70%',
            sm: '70%',
            md: 'calc(50% - 16px)',
            lg: '333px',
          },
          width: {
            xs: 'calc(50% - 16px)',
            sm: 'calc(50% - 16px)',
            md: 'calc(33.33% - 16px)',
            lg: 'calc(25% - 16px)',
          },
        }}
      />
    </Box>
  );
};

export default ServiceCardLoading;
